import { Typography } from "@mui/material";
import React from "react";
import { Translate } from "orion-components/i18n";

const PlaybackStopped = () => {
	const styles = {
		wrapper: {
			display: "flex",
			alignItems: "center",
			flex: "auto",
			flexDirection: "column",
			justifyContent: "center",
			padding: "2.5%",
			zIndex: 1901
		},
		button: {
			zIndex: 99,
			marginTop: 12
		}
	};
	return (
		<div className="camera-text-wrapper" style={styles.wrapper}>
			<Typography align="center" variant="subtitle1">
				<Translate value="global.CBComponents.video.webRTCPlayer.playbackStopped" />
			</Typography>
		</div>
	);
};

export default PlaybackStopped;
